export enum ApiOrderProductsField {
  LineTaxRate = 'line_tax_rate',
  ProductType = 'product_type',
  SumLinePriceTaxExcluded = 'sum_line_price_tax_excluded',
  SumLinePriceTaxIncluded = 'sum_line_price_tax_included',
  SumLineTaxAmount = 'sum_line_tax_amount',
}

export enum ApiOrderProductsAggregate {
  ProductType = 'productType',
  TaxRate = 'taxRate',
}
